module.exports = __webpack_public_path__ + "static/media/bg3.f807b37b.jpg";